import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { ONBOARDING_STEPS_COMPLETED } from "../user/onboardingStepsCompleted";

const DEPLOY_APP = gql(`
    mutation DEPLOY_APP($appVersionID: ID!, $skipMetadataUpdate: Boolean) {
        appDeploy(appVersionID: $appVersionID, input: {skipMetadataUpdate: $skipMetadataUpdate}) {
            id
            status
            proxyURL
            appVersion {
                id
                version
                message
            }

        }
    }
`);

export function useDeployApp() {
  return useMutation(DEPLOY_APP, {
    refetchQueries: [ONBOARDING_STEPS_COMPLETED]
  });
}
